"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlanCatalogResponseDto = instanceOfPlanCatalogResponseDto;
exports.PlanCatalogResponseDtoFromJSON = PlanCatalogResponseDtoFromJSON;
exports.PlanCatalogResponseDtoFromJSONTyped = PlanCatalogResponseDtoFromJSONTyped;
exports.PlanCatalogResponseDtoToJSON = PlanCatalogResponseDtoToJSON;
exports.PlanCatalogResponseDtoToJSONTyped = PlanCatalogResponseDtoToJSONTyped;
var LaunchPromoDto_1 = require("./LaunchPromoDto");
var PlanCatalogItemDto_1 = require("./PlanCatalogItemDto");
/**
 * Check if a given object implements the PlanCatalogResponseDto interface.
 */
function instanceOfPlanCatalogResponseDto(value) {
    if (!('items' in value) || value['items'] === undefined)
        return false;
    if (!('launchPromo' in value) || value['launchPromo'] === undefined)
        return false;
    return true;
}
function PlanCatalogResponseDtoFromJSON(json) {
    return PlanCatalogResponseDtoFromJSONTyped(json, false);
}
function PlanCatalogResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'items': (json['items'].map(PlanCatalogItemDto_1.PlanCatalogItemDtoFromJSON)),
        'launchPromo': (0, LaunchPromoDto_1.LaunchPromoDtoFromJSON)(json['launchPromo']),
    };
}
function PlanCatalogResponseDtoToJSON(json) {
    return PlanCatalogResponseDtoToJSONTyped(json, false);
}
function PlanCatalogResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'items': (value['items'].map(PlanCatalogItemDto_1.PlanCatalogItemDtoToJSON)),
        'launchPromo': (0, LaunchPromoDto_1.LaunchPromoDtoToJSON)(value['launchPromo']),
    };
}
